import React, { useEffect } from 'lib/react';
import CommonCustomCover from 'commonComponents/customCover/CustomCover.component';
import { useSelector, useDispatch } from 'lib/redux';
import { initializeCoverPageInputFields, updateInputFieldValue } from 'features/orderPreferences/OrderPreferences.actions';
import { useTranslation } from 'lib/translation';
import { getPropertyValues } from 'features/orderPreferences/OrderPreferences.utils';
import {
  EVGrid, EVCheckbox, EVInputLabel, makeStyles,
} from 'lib/components';
import clsx from 'clsx';
import PageHeading from '../PageHeading.component';

const useStyles = makeStyles((theme) => ({
  customCoverPage: {
    display: 'flex',
    flexDirection: 'column',
    padding: '24px',
    paddingBottom: 0,
    flex: '1 1 auto',
    gap: '24px',
    '&.isFinalizedOrderPage': {
      padding: '0px',
    },
  },
  checkChanges: {
    padding: 0,
  },
  descriptionText: {
    color: theme.evPalette.charcoal[800],
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '24px',
    '& .value,&.value': {
      fontSize: '14px',
    },
  },
}));

function CustomCover() {
  const classes = useStyles();
  const orderPreferences = useSelector(({ userData }) => userData.orderPreferences);
  const inputFieldValues = useSelector(({ orderPreference }) => orderPreference.inputFieldValues);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { isAdmin, reportOptionsCustomCover } = orderPreferences;

  useEffect(() => {
    dispatch(initializeCoverPageInputFields(orderPreferences));
  }, []);

  const handlePropertyChange = (propertyName, key, value) => (dispatch(updateInputFieldValue(propertyName, key, value)));
  const handleCustomCoverCheckboxChange = () => handlePropertyChange(
    'reportOptionsCustomCover',
    'value',
    Number(!getPropertyValues(orderPreferences, inputFieldValues, 'reportOptionsCustomCover')?.value),
  );

  const handleAllowSubAccountsChange = ({ target: { checked } }) => handlePropertyChange('reportOptionsCustomCover', 'allowSubAccounts', !checked);
  const showCoverPageSettings = isAdmin || reportOptionsCustomCover?.allowSubAccounts;
  return (
    <>
      <PageHeading
        title={t('order_preferences__custom_cover_page')}
        description={t(
          showCoverPageSettings
            ? 'order_preferences__custom_cover_page_description_admin'
            : 'order_preferences__custom_cover_page_description',
        )}
      />
      <EVGrid className={clsx(classes.customCoverPage)}>
        {showCoverPageSettings && (
        <EVGrid style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <EVCheckbox
            checked={getPropertyValues(orderPreferences, inputFieldValues, 'reportOptionsCustomCover')?.value}
            name="reportOptionsCustomCover"
            id="reportOptionsCustomCover"
            color="primary"
            onChange={handleCustomCoverCheckboxChange}
            className={classes.checkChanges}
          />
          <EVInputLabel htmlFor="reportOptionsCustomCover" className={classes.descriptionText}>
            {t('order_preferences__include_custom_cover_checkbox_text')}
          </EVInputLabel>
        </EVGrid>
        )}
        <CommonCustomCover
          orderPreferences={orderPreferences}
          inputFieldValues={inputFieldValues}
          handlePropertyChange={handlePropertyChange}
        />
        {showCoverPageSettings && (
        <EVGrid style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <EVCheckbox
            checked={!getPropertyValues(orderPreferences, inputFieldValues, 'reportOptionsCustomCover')?.allowSubAccounts}
            name="reportOptionsCustomCoverAllowSubAccounts"
            id="reportOptionsCustomCoverAllowSubAccounts"
            color="primary"
            onChange={handleAllowSubAccountsChange}
            className={classes.checkChanges}
          />
          <EVInputLabel htmlFor="reportOptionsCustomCoverAllowSubAccounts" className={clsx(classes.descriptionText, 'value')}>
            {t('order_preferences__cover_page__allow_sub_accounts')}
          </EVInputLabel>
        </EVGrid>
        )}
      </EVGrid>
    </>

  );
}

export default CustomCover;
